// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tlGjCj {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: var(--surface-neutral-white);
  position: relative;
  box-sizing: border-box;
  gap: 24px;
  text-align: left;
  font-size: 14px;
  color: #1f1f1f;
  font-family: var(--font-family-base);
}

.H7V2rH {
  flex: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.eMJSK7 {
  font-weight: 600;
  font-family: var(--font-family-base);
  color: #1f1f1f;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  font-size: 14px;
  line-height: 1.8em;
}

.SGzSFg {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.VLcMHU {
  font-size: var(--type-label-md-font-size, 14px);
  color: var(--text-neutral-dark, #1f1f1f);
  font-weight: var(--font-weight-regular, 400);
  margin: 0;
  padding: 0;
}

.XoNqDP {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.LdpG_B {
  width: 100% !important;
  height: var(--input-height, 40px) !important;
  border-radius: var(--radius-m, 4px);
}

.npK2_v {
  width: 100% !important;
  height: var(--input-height, 40px) !important;
  border-radius: var(--radius-m, 4px);
  border: 1px solid transparent !important;
  background: transparent !important;
  font-size: var(--font-size-md, 14px) !important;
  color: var(--text-neutral-dark) !important;
  outline: none !important;
  transition: border 0.2s !important;
  font-family: var(--font-family-base) !important;
}

.npK2_v:focus {
  border-color: var(--surface-primary-medium, #d64000) !important;
  outline-offset: var(--spacing-0, 0) !important;
}

.npK2_v:invalid {
  border-color: var(--surface-primary-medium, #d64000) !important;
  outline-offset: var(--spacing-0, 0) !important;
}

.k9243_ {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
  gap: var(--spacing-2, 16px);
  background-color: var(--surface-neutral-white);
  padding: 15px 0 0 0;
}

.fY4QB3 {
  height: 40px;
  width: 100px;
  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);
  border-radius: var(--button-border-radius, 4px);
  background: var(--surface-neutral-white, #ffffff);
  border: 2px solid var(--brand-tr-orange, #d64000);
  color: var(--text-primary-medium, #1f1f1f);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--font-size-md, 14px);
  cursor: pointer;
  transition: all 0.2s ease;
}

.fY4QB3:hover {
  background: var(--surface-neutral-pale, #f5f5f5);
}

.cTuhhg {
  height: 40px;
  width: 100px;
  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);
  border-radius: var(--button-border-radius, 4px);
  background: var(--brand-tr-orange, #d64000);
  border: 2px solid var(--brand-tr-orange, #d64000);
  color: var(--text-neutral-white, #ffffff);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--font-size-md, 14px);
  cursor: pointer;
  transition: all 0.2s ease;
}

.cTuhhg:hover:not(:disabled) {
  background: var(--brand-tr-orange-dark, #b33600);
  border-color: var(--brand-tr-orange-dark, #b33600);
}

.cTuhhg:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  background: var(--disabled-subtle-surface, #f5f5f5);
  color: var(--text-neutral-strong, #666666);
  border: 2px solid var(--disabled-subtle-surface, #f5f5f5);
}

/* Responsividade para telas menores */
@media (max-width: 768px) {
  .tlGjCj {
    padding: 16px;
    gap: 16px;
  }

  .H7V2rH {
    gap: 16px;
  }

  .SGzSFg {
    gap: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/PaymentBilletBarcode/PaymentBilletBarcode.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,+CAA+C;EAC/C,wCAAwC;EACxC,4CAA4C;EAC5C,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;EAC5C,mCAAmC;EACnC,wCAAwC;EACxC,kCAAkC;EAClC,+CAA+C;EAC/C,0CAA0C;EAC1C,wBAAwB;EACxB,kCAAkC;EAClC,+CAA+C;AACjD;;AAEA;EACE,+DAA+D;EAC/D,8CAA8C;AAChD;;AAEA;EACE,+DAA+D;EAC/D,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,2BAA2B;EAC3B,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uDAAuD;EACvD,+CAA+C;EAC/C,iDAAiD;EACjD,iDAAiD;EACjD,0CAA0C;EAC1C,oCAAoC;EACpC,6CAA6C;EAC7C,oCAAoC;EACpC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uDAAuD;EACvD,+CAA+C;EAC/C,2CAA2C;EAC3C,iDAAiD;EACjD,yCAAyC;EACzC,oCAAoC;EACpC,6CAA6C;EAC7C,oCAAoC;EACpC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;EAChD,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mDAAmD;EACnD,0CAA0C;EAC1C,yDAAyD;AAC3D;;AAEA,sCAAsC;AACtC;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  background-color: var(--surface-neutral-white);\n  position: relative;\n  box-sizing: border-box;\n  gap: 24px;\n  text-align: left;\n  font-size: 14px;\n  color: #1f1f1f;\n  font-family: var(--font-family-base);\n}\n\n.content {\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.title {\n  font-weight: 600;\n  font-family: var(--font-family-base);\n  color: #1f1f1f;\n  display: flex;\n  align-items: center;\n  margin: 0;\n  padding: 0;\n  font-size: 14px;\n  line-height: 1.8em;\n}\n\n.inputSection {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n}\n\n.label {\n  font-size: var(--type-label-md-font-size, 14px);\n  color: var(--text-neutral-dark, #1f1f1f);\n  font-weight: var(--font-weight-regular, 400);\n  margin: 0;\n  padding: 0;\n}\n\n.inputWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.inputContainer {\n  width: 100% !important;\n  height: var(--input-height, 40px) !important;\n  border-radius: var(--radius-m, 4px);\n}\n\n.input {\n  width: 100% !important;\n  height: var(--input-height, 40px) !important;\n  border-radius: var(--radius-m, 4px);\n  border: 1px solid transparent !important;\n  background: transparent !important;\n  font-size: var(--font-size-md, 14px) !important;\n  color: var(--text-neutral-dark) !important;\n  outline: none !important;\n  transition: border 0.2s !important;\n  font-family: var(--font-family-base) !important;\n}\n\n.input:focus {\n  border-color: var(--surface-primary-medium, #d64000) !important;\n  outline-offset: var(--spacing-0, 0) !important;\n}\n\n.input:invalid {\n  border-color: var(--surface-primary-medium, #d64000) !important;\n  outline-offset: var(--spacing-0, 0) !important;\n}\n\n.footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  width: 100%;\n  gap: var(--spacing-2, 16px);\n  background-color: var(--surface-neutral-white);\n  padding: 15px 0 0 0;\n}\n\n.backButton {\n  height: 40px;\n  width: 100px;\n  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);\n  border-radius: var(--button-border-radius, 4px);\n  background: var(--surface-neutral-white, #ffffff);\n  border: 2px solid var(--brand-tr-orange, #d64000);\n  color: var(--text-primary-medium, #1f1f1f);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold, 600);\n  font-size: var(--font-size-md, 14px);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.backButton:hover {\n  background: var(--surface-neutral-pale, #f5f5f5);\n}\n\n.nextButton {\n  height: 40px;\n  width: 100px;\n  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);\n  border-radius: var(--button-border-radius, 4px);\n  background: var(--brand-tr-orange, #d64000);\n  border: 2px solid var(--brand-tr-orange, #d64000);\n  color: var(--text-neutral-white, #ffffff);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold, 600);\n  font-size: var(--font-size-md, 14px);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.nextButton:hover:not(:disabled) {\n  background: var(--brand-tr-orange-dark, #b33600);\n  border-color: var(--brand-tr-orange-dark, #b33600);\n}\n\n.nextButton:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  background: var(--disabled-subtle-surface, #f5f5f5);\n  color: var(--text-neutral-strong, #666666);\n  border: 2px solid var(--disabled-subtle-surface, #f5f5f5);\n}\n\n/* Responsividade para telas menores */\n@media (max-width: 768px) {\n  .container {\n    padding: 16px;\n    gap: 16px;\n  }\n\n  .content {\n    gap: 16px;\n  }\n\n  .inputSection {\n    gap: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `tlGjCj`,
	"content": `H7V2rH`,
	"title": `eMJSK7`,
	"inputSection": `SGzSFg`,
	"label": `VLcMHU`,
	"inputWrapper": `XoNqDP`,
	"inputContainer": `LdpG_B`,
	"input": `npK2_v`,
	"footer": `k9243_`,
	"backButton": `fY4QB3`,
	"nextButton": `cTuhhg`
};
module.exports = ___CSS_LOADER_EXPORT___;
